import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SharedAnnualLeavingService {
  elementId: number | undefined;
  elementUid: string | undefined;

  eventNo: string | undefined;
  isAl: boolean;
}
